import { FIELD_LABELS, MODEL_NOT_LISTED, STEP_FIELDS, type FormValues } from '../../shared/schema'

type FormField = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement

const GROUP_TITLES = ['Donor Information', 'Vehicle Information', 'Location & Pickup'] as const

/** Human-readable value for the summary (option text for selects, Yes/No for checkboxes). */
function displayValue(field: FormField): string {
  if (field instanceof HTMLInputElement && field.type === 'checkbox') {
    return field.checked ? 'Yes' : 'No'
  }
  if (field instanceof HTMLSelectElement) {
    return field.value === '' ? '' : (field.selectedOptions[0]?.textContent?.trim() ?? field.value)
  }
  return field.value.trim()
}

/** Render the step-4 read-back of everything the donor entered. */
export function renderReviewSummary(form: HTMLFormElement, onEdit?: (stepIndex: number) => void): void {
  const container = document.getElementById('reviewSummary')
  if (!container) return

  const groups: HTMLElement[] = []

  GROUP_TITLES.forEach((title, stepIndex) => {
    const dl = document.createElement('dl')

    for (const name of STEP_FIELDS[stepIndex] ?? []) {
      const field = form.elements.namedItem(name)
      if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) continue

      // "Not listed" model: the typed-in modelOther row carries the value.
      if (name === 'model' && field.value === MODEL_NOT_LISTED) continue

      const value = displayValue(field)
      if (value === '') continue

      const dt = document.createElement('dt')
      dt.textContent = FIELD_LABELS[name as keyof FormValues] ?? name
      const dd = document.createElement('dd')
      dd.textContent = value
      dl.append(dt, dd)
    }

    if (!dl.childElementCount) return

    const section = document.createElement('section')
    section.className = 'review-group'
    const header = document.createElement('div')
    header.className = 'review-group-header'
    const h3 = document.createElement('h3')
    h3.textContent = title
    header.append(h3)
    if (onEdit) {
      const edit = document.createElement('button')
      edit.type = 'button'
      edit.className = 'review-edit'
      edit.textContent = 'Edit'
      edit.setAttribute('aria-label', `Edit ${title}`)
      edit.addEventListener('click', () => onEdit(stepIndex))
      header.append(edit)
    }
    section.append(header, dl)
    groups.push(section)
  })

  container.replaceChildren(...groups)
}
